import { useMediaQuery } from "react-responsive";

export const calculateRemValue = (pixels) => {
// Directly calculate scaled pixel value value (based on root font size) for each render
	const baseFontSize = 16;
	const browserFontSize = parseFloat(
		getComputedStyle(document.documentElement).fontSize
	);

	let scaledPixelValue = pixels * (browserFontSize / baseFontSize);
	return scaledPixelValue;
}


const useDynamicMediaQuery = (pixels) => {
	
	const scaledPixelValue = calculateRemValue(pixels);

	const isDesktop = useMediaQuery({
		query: `(min-width: ${scaledPixelValue}px)`,
	});

	return isDesktop;
};

export default useDynamicMediaQuery;
